import { useEffect, useRef } from 'react';
import useLmsCourseReviewHook from './useLmsCourseReviewHook';
import useResolutionDialogHook from './useResolutionDialogHook';

/**
 * Composes queue list state, resolution dialog state, and syncs the grid's
 * open-resolution callback with the dialog opener.
 */
const useLmsCourseReviewPageHook = () => {
  const openResolutionRef = useRef(() => {});

  const queue = useLmsCourseReviewHook({
    onOpenResolution: (item) => openResolutionRef.current(item),
  });

  const resolution = useResolutionDialogHook({
    onResolved: queue.refreshQueue,
    onToast: queue.setToast,
  });

  useEffect(() => {
    openResolutionRef.current = resolution.dialog.open;
  }, [resolution.dialog.open]);

  return { queue, resolution };
};

export default useLmsCourseReviewPageHook;
